/* unplugin-vue-components disabled */import { render } from "./IconList.vue?vue&type=template&id=2cad1417&scoped=true"
const script = {}

import "./IconList.vue?vue&type=style&index=0&id=2cad1417&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cad1417"]])

export default __exports__